exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "filter.v-text-field>.v-input__control>.v-input__slot:after,filter.v-text-field>.v-input__control>.v-input__slot:before{border-style:none}", ""]);

// exports
